import React, { Component } from 'react'
import {
    Button,
    withStyles,
    Grid,
    Paper,
    Typography,
    FormControl,
    Card,
    TextField,
    CardContent,
    InputAdornment,
    IconButton,
    FormHelperText,
    WithStyles,createStyles
} from '@material-ui/core';
import { connect,ConnectedProps } from 'react-redux';
import ProviderPermissions from './ProviderPermissions'
import { compose } from 'redux';
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import { AppConstants } from "../../../../constants/appconstants"
import { ClusterProviders } from '../../../../constants/clusterconstants';
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import InfoIcon from '@material-ui/icons/Info';
import BackdropLoader from '../../../../components/loader/BackdropLoader'
import { validatePermission, getProviderConfig } from '../../redux/actions'
import { withTranslation,WithTranslation } from 'react-i18next'
import Autocomplete from '@material-ui/lab/Autocomplete';
import MuiTextField from '../../../../components/textfield/MuiTextField';
import { Dispatch } from 'redux';
import { ClusterCreateModel } from '../../../../models/Cluster.model';
import { TclusterProvider } from '../../../../models/Cluster.model';

/* istanbul ignore next */
const useStyles = () => createStyles({
    actions: {
        display: 'flex',
        justifyContent: 'center',
        marginBottom:'2rem'
    },
    container: {
        marginTop: 20,
        minHeight: '20rem',
    },
    // iconContainer: {
    //     flex: 1,
    //     alignItems: 'center',
    //     display: 'flex',
    //     flexDirection: 'column',
    //     justifyContent: 'flex-end',
    // },
    selectbox: {
        height: 30
    },
    formControl: {
        minWidth: '90%',
    },
    buttonsContainer: {
        display: 'flex',
        flexDirection: 'column',
        flex: 1,
        justifyContent: 'space-between',
        padding: '1rem',
    },

    continueButton: {
        marginTop: '1rem'
    },
    logo: {
        height: 150,
        width: 'auto',
        objectFit: 'cover',
        padding: '10px 0'
    },
    center: {
        justifyContent: 'center'
    },
    root: {
        marginTop: 0
    },
    paperContainer: {
        height: 180,
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
    },
    icon: {
        fontSize: 100
    },
    iconContainer: {
        width: '100%',
        height: 180,
        padding:0
    },
    selectTemplateTypography: {
        marginTop: '1rem',
        textTransform: 'none'
    },
    checkselect: {
        position: 'absolute',
        top: 20,
        right: 15,

    },
    branchInfo: {
        display: 'flex',
        alignItems: 'center'
    }
});


interface Iprops extends PropsFromRedux, WithStyles, WithTranslation {
  handleChange: (
    step: number,
    data: Partial<ClusterCreateModel>
  ) => void;
  activeStep: number;
}

interface PermissionCount {
    hasPermission: number;
    noPermission: number;
}

interface Istate extends Pick<
ClusterCreateModel,
| "provider"
| "region"
| "access_key"
| "secret_key"
>  {
    currentStep: number;
    isShowAccessKey: boolean;
    isShowSecretKey: boolean;
    selectedFile: null | File;
    permissionStatus: boolean;
    permissionCount: PermissionCount;
    project_id: string;
}

export class Provider extends Component<Iprops,Istate> {
    constructor(props:Iprops) {
        super(props);
        this.state = {
            currentStep: 0,
            // selectedProvider: "1",
            provider: "",
            region: "Select",
            access_key: "",
            secret_key: "",
            isShowAccessKey: false,
            isShowSecretKey: false,
            selectedFile: null,
            permissionStatus: false,
            permissionCount: { hasPermission: 0, noPermission : 0 },
            project_id: ''
        }
    }
    
    handleContinue = () => {
        //const { selectedProvider } = this.state;
        const data = { 
            provider: this.state.provider,
            region: this.state.region,
            access_key: this.state.access_key,
            secret_key: this.state.secret_key,
            credentials: this.props.gcpFilePath,
            project_id: this.state.project_id
        };
        this.props.handleChange(this.state.currentStep + 1, data)
    }

    UNSAFE_componentWillReceiveProps(nextProps:Iprops) {
        if(nextProps) {
          if(!this.props.validationData && nextProps.validationData){
            const permissionCount = {
                hasPermission: nextProps.validationData.has_permission ? nextProps.validationData.has_permission.length : 0,
                noPermission: nextProps.validationData.no_permission ? nextProps.validationData.no_permission.length : 0
            }
            this.setState({
                permissionCount,
                permissionStatus : permissionCount.noPermission === 0 ? true : false
            })
          }
        }
    }

    handleProviderSelection = (item:TclusterProvider) => {
        this.props.getProviderConfig(item.provider);
        this.setState({
            provider: item.provider,
            region: "Select",
            access_key: "",
            secret_key: "",          
            selectedFile: null,
            permissionStatus: false,
            permissionCount: { hasPermission: 0, noPermission : 0 }  
        })
    }

    handleAccessKeyChange = (e:React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
        this.setState({
            access_key: e.target.value
        })
    }

    handleShowAccessKey = () => {
        this.setState({
            isShowAccessKey: !this.state.isShowAccessKey
        })
    }
    
    handleSecretKeyChange = (e:React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
        this.setState({
            secret_key: e.target.value
        })
    }

    handleShowSecretKey = () => {
        this.setState({
            isShowSecretKey : !this.state.isShowSecretKey
        })
    }

    handleRegionChange = (e: React.ChangeEvent<{}>, newValue:unknown) => {
        // if(e.target.value === 'Select'){
        //     this.setState({
        //         selectedRepository : e.target.value,
        //         isRepoDropDownFeildError :true,
        //         repoDropDownErrorMessage : 'Please select repository',  
        //     })
        // } else {
        //     this.setState({
        //         selectedRepository : e.target.value,
        //         isRepoDropDownFeildError :false,
        //         repoDropDownErrorMessage : '',  
        //     })
        // }
        this.setState({
            region: newValue as string
        })
    }

    handleValidate = () => {
        let jsonBody: Partial<ClusterCreateModel> = {
            provider:  this.state.provider,
            region : this.state.region
        };
        let uploadBody = null;
        //{provider(gcp, eks), region,  access_key for aws, secret_key, for aws,  credential (file path - use /upload api for geting path for gcp}
        if(this.state.provider === AppConstants.ClusterProvider.EKS)
        {
            jsonBody.access_key = this.state.access_key;
            jsonBody.secret_key = this.state.secret_key;
        }
        else if (this.state.provider === AppConstants.ClusterProvider.GCP)
        {
            if (this.state.selectedFile) {
                uploadBody = new FormData(); 
                uploadBody.append('file_name', this.state.selectedFile.name);
                //uploadBody.append('file_type', this.state.selectedFile.type);
                uploadBody.append('file_type', "json");
                uploadBody.append('file', this.state.selectedFile);
            }
        }
        this.props.validatePermission(jsonBody, uploadBody);
    }
    
    onFileChange = (e:React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
        if ("files" in e.target && e.target.files && e.target.files.length > 0) {
            const _file = e.target.files[0];
            if (_file) { //&& _file.size <= 102400
                this.setState({
                    selectedFile: _file
                });
                var reader = new FileReader();
                const $this = this; 
                reader.onload = function(event) {
                    try {
                        if(event && event.target && event.target.result)
                        {
                           const _jsonFile = JSON.parse(event.target.result.toString())
                           if(_jsonFile)
                           {
                               $this.setState({ project_id : _jsonFile.project_id })
                           }
                        } 
                    }
                    catch (err) {
                        console.log(err);
                    }
                };
                reader.readAsText(_file);
            }
            else {
                // this.setState({
                //     errorMsg: 'File should not be more than 100kb'
                // })
            }
        }
    };

    isFormValid = () => {
        let valid = false;
        if(this.state.region !== "Select") {
            if( this.state.provider === AppConstants.ClusterProvider.EKS)
            {
                if(this.state.access_key.trim() !== "" && this.state.secret_key.trim() !== "")    
                    valid = true;
            }
            else if( this.state.provider === AppConstants.ClusterProvider.GCP)
            {
                if(this.state.selectedFile)
                    valid = true;
            }
        }
        return !valid;    
    }
    
    render() {
        const { classes, validationData, providerConfig, t } = this.props;
        const _region = providerConfig && providerConfig.properties && providerConfig.properties.region;
        if (this.props.activeStep !== this.state.currentStep) {
            return null
        }
        return (
            <div data-test="main-container">
                <Grid container spacing={2} className={classes.root}>
                    {
                        ClusterProviders && ClusterProviders.length > 0 && ClusterProviders.map((item:TclusterProvider, index:number) => (
                            <Grid item xs={12} md={2} key={ index }>
                                <Button className={ classes.iconContainer } onClick={() => this.handleProviderSelection(item) } disabled = {this.state.permissionStatus} data-test="provider-btn">
                                    <Paper className={classes.paperContainer}>
                                        {
                                            this.state.provider === item.provider && 
                                            <CheckCircleIcon color="primary" className={classes.checkselect} data-test="check-icon" />
                                        }
                                        <div  >
                                            <img src={ item.image } width="80px" alt="" data-test="provider-img"/>
                                        </div>
                                        <Typography className={classes.selectTemplateTypography} variant="h6" color="textPrimary" data-test="provider-name">
                                            {item.name}
                                        </Typography>
                                    </Paper>
                                </Button>
                            </Grid>
                        ))
                    }

                    <Grid item xs={12} md={2}>
                        <Button className={classes.iconContainer}>
                            <Paper className={classes.paperContainer}>

                                <div className="ribbon ribbon-top-right"><span>{t('Cluster.Provider.comingSoon')}</span></div>
                                <div>
                                    <img src="/images/provider/aks.svg" width="80px" alt=""/>
                                </div>
                                <Typography className={classes.selectTemplateTypography} variant="h6" color="textPrimary">
                                {t('Cluster.Provider.azure')}
                                </Typography>
                            </Paper>
                        </Button>
                    </Grid>

                    {
                        this.state.provider !== "" &&
                        <Grid item xs={12} md={12}>
                            <Card>
                                <CardContent>
                                    <Grid container spacing={2}>
                                        {
                                            this.state.provider === AppConstants.ClusterProvider.EKS &&
                                            <Grid item xs={ 12 }>
                                                <Grid container spacing={3}>
                                                    <Grid item sm={6} xs={12}>
                                                        <Grid container direction="column" spacing={2}>
                                                            <Grid item className={classes.branchInfo}>
                                                                <Typography variant='h5'> {t('Cluster.Provider.accessKey')} </Typography>
                                                                <InfoIcon color='primary'
                                                                  aria-describedby="webhook_pop"
                                                                    //onMouseEnter={(e) => this.handleMouseOver(e)}
                                                                />
                                                            </Grid>
                                                            <Grid item>
                                                                <TextField style={{width:"0px", height:"0px"}}/>
                                                                {/* <OutlinedInput
                                                                  value={this.state.access_key}
                                                                  variant="outlined"
                                                                    //size="small"
                                                                  fullWidth
                                                                  margin="normal"
                                                                  name="access_key"
                                                                  type={ this.state.isShowAccessKey ? "text" : "password" }
                                                                  onChange={ (e) => this.handleAccessKeyChange(e) }
                                                                  disabled={this.state.permissionStatus}
                                                                  endAdornment={
                                                                    //   <>
                                                                          <InputAdornment position="end">
                                                                              <IconButton
                                                                                aria-label="toggle visibility"
                                                                                onClick={() => this.handleShowAccessKey() }
                                                                                edge="end"
                                                                                data-test="toggle-accessKey-visibility"
                                                                              >
                                                                                  {this.state.isShowAccessKey ? <Visibility /> : <VisibilityOff /> }
                                                                              </IconButton>
                                                                          </InputAdornment>
                                                                    //   </>
                                                                    }
                                                                    data-test="access-key-input"
                                                                >
                                                                </OutlinedInput> */}
                                                                <MuiTextField
                                                                value={this.state.access_key}
                                                                margin="normal"
                                                                name="access_key"
                                                                type={ this.state.isShowAccessKey ? "text" : "password" }
                                                                onChange={ (e) => this.handleAccessKeyChange(e) }
                                                                disabled={this.state.permissionStatus}
                                                                InputProps={{
                                                                    endAdornment:(
                                                                        <InputAdornment position="end">
                                                                              <IconButton
                                                                                aria-label="toggle visibility"
                                                                                onClick={() => this.handleShowAccessKey() }
                                                                                edge="end"
                                                                                data-test="toggle-accessKey-visibility"
                                                                              >
                                                                                  {this.state.isShowAccessKey ? <Visibility /> : <VisibilityOff /> }
                                                                              </IconButton>
                                                                        </InputAdornment>
                                                                    )
                                                                }}
                                                                data-test="access-key-input"
                                                                />
                                                               
                                                            </Grid>
                                                        </Grid>
                                                    </Grid>
                                                    <Grid item sm={6} xs={12}>
                                                        <Grid container direction="column" spacing={2}>
                                                            <Grid item className={classes.branchInfo}>
                                                                <Typography variant='h5' > {t('Cluster.Provider.secretKey')} </Typography>
                                                                <InfoIcon color='primary'
                                                                  aria-describedby="webhook_pop"
                                                                    //onMouseEnter={(e) => this.handleMouseOver(e)}
                                                                />
                                                            </Grid>
                                                            <Grid item >
                                                                {/* <OutlinedInput
                                                                  value={this.state.secret_key}
                                                                  variant="outlined"
                                                                    //size="small"
                                                                  margin="normal"
                                                                  fullWidth
                                                                  name="secret_key"
                                                                  type={ this.state.isShowSecretKey ? "text" : "password" }
                                                                  onChange={ (e) => this.handleSecretKeyChange(e) }
                                                                  disabled={this.state.permissionStatus}
                                                                  endAdornment={
                                                                    //   <>
                                                                          <InputAdornment position="end">
                                                                              <IconButton
                                                                                aria-label="toggle visibility"
                                                                                onClick={() => this.handleShowSecretKey() }
                                                                                edge="end"
                                                                                data-test="toggle-secretKey-visibility"
                                                                              >
                                                                                  {this.state.isShowSecretKey ? <Visibility /> : <VisibilityOff /> }
                                                                              </IconButton>
                                                                          </InputAdornment>
                                                                    //   </>
                                                                    }
                                                                    data-test="secret-key-input"
                                                                >
                                                                </OutlinedInput> */}
                                                                <MuiTextField
                                                                value={this.state.secret_key}
                                                                margin="normal"
                                                                name="secret_key"
                                                                type={ this.state.isShowSecretKey ? "text" : "password" }
                                                                onChange={ (e) => this.handleSecretKeyChange(e) }
                                                                disabled={this.state.permissionStatus}
                                                                InputProps={{
                                                                    endAdornment:(
                                                                        <InputAdornment position="end">
                                                                              <IconButton
                                                                                aria-label="toggle visibility"
                                                                                onClick={() => this.handleShowSecretKey() }
                                                                                edge="end"
                                                                                data-test="toggle-secretKey-visibility"
                                                                              >
                                                                                  {this.state.isShowSecretKey ? <Visibility /> : <VisibilityOff /> }
                                                                              </IconButton>
                                                                        </InputAdornment>
                                                                    )
                                                                }}
                                                                data-test="secret-key-input"
                                                                />
                                                               
                                                            </Grid>
                                                        </Grid>
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                        }
                                        {
                                            this.state.provider === AppConstants.ClusterProvider.GCP &&
                                            <Grid item md={6} xs={12}>
                                                <Typography variant='h5' > {t('Cluster.Provider.serviceAccount')} </Typography>
                                                <TextField
                                                  id=""
                                                  type="file"
                                                  title=""
                                                  color="primary"
                                                  name=""
                                                  variant="outlined"
                                                  className="w-100"
                                                  margin="normal"
                                                  onChange={this.onFileChange}
                                                  disabled={this.state.permissionStatus}
                                                  data-test="service-account-file"
                                                />
                                            </Grid>
                                        }
                                        <Grid item xs={12} md={6}>
                                            <Grid container direction="column">
                                                <Grid item className={classes.branchInfo}>
                                                    <Typography variant='h5'> {t('Cluster.Provider.region')} </Typography>
                                                </Grid>
                                                <Grid item>
                                                    <FormControl className="w-100"  variant="outlined" margin="normal">
                                                         {/* <Select
                                                          name='region'
                                                          value={ this.state.region }
                                                          color='primary'
                                                          onChange={(e) => this.handleRegionChange(e)}
                                                          disabled={this.state.permissionStatus}
                                                          MenuProps={{
                                                            getContentAnchorEl: null,
                                                            anchorOrigin: {
                                                                vertical: "bottom",
                                                                horizontal: "left"
                                                            }
                                                        }}
                                                          data-test="provider-region-select"
                                                        >
                                                            <MenuItem value="Select"> {t('Cluster.Provider.selectRegion')}</MenuItem> */}
                                                            {/* {
                                                            this.state.provider === AppConstants.ClusterProvider.GCP && ClusterRegions && ClusterRegions.GCP && ClusterRegions.GCP.length > 0 &&
                                                            ClusterRegions.GCP.map((item) => (
                                                                <MenuItem value={item.value}>{item.name}</MenuItem>
                                                            ))
                                                        }
                                                        {
                                                            this.state.provider === AppConstants.ClusterProvider.EKS && ClusterRegions && ClusterRegions.EKS && ClusterRegions.EKS.length > 0 &&
                                                            ClusterRegions.EKS.map((item) => (
                                                                <MenuItem value={item.value}>{item.name}</MenuItem>
                                                            ))
                                                        } */}
                                                            {/* { 
                                                            selectedClusterConstants && selectedClusterConstants.regions && selectedClusterConstants.regions.length > 0 &&
                                                            selectedClusterConstants.regions.map((item) => (
                                                                <MenuItem value={item.value}>{item.value}</MenuItem>
                                                            ))
                                                        } */}
                                                            {/* {
                                                            _region && _region.items && _region.items.length > 0 &&
                                                            _region.items.map((reg, ind) =>  <MenuItem value={ reg } key={ ind } data-test="provider-region-item">{ reg }</MenuItem>)
                                                        }
                                                        </Select> */}
                                                        <Autocomplete
                                                            options={_region?.items.map((reg:string) => reg)}
                                                            disabled={this.state.permissionStatus}
                                                            onChange={(e, newValue) => this.handleRegionChange(e, newValue)}
                                                            renderInput={(params) => <TextField label="Select Region" {...params} variant="outlined" color="primary" />}
                                                            data-test="provider-region-select"
                                                        />
                                                        <FormHelperText data-test="provider-region-helper">{ _region && _region.description }</FormHelperText>
                                                    </FormControl>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </CardContent>
                            </Card>
                        </Grid>
                    }
                </Grid>

                <ProviderPermissions validationData={ validationData } provider={this.state.provider} data-test="provider-permission"/>
                { this.props.isValidatingPermission && <BackdropLoader message={t('Cluster.Provider.validatingPermission')} />}
                {
                    <div className={classes.actions}>
                        <Grid container className={classes.continueButton} justify="center" spacing={2}>
                            {
                                this.state.provider !== "" && !this.state.permissionStatus &&
                                <Grid item xl={1} md={2} xs={6}>
                                    <Button variant="contained" color='primary' fullWidth onClick={() => this.handleValidate()} disabled = { this.isFormValid() } data-test="validate-btn">
                                        { this.state.permissionCount.noPermission > 0 ? t('Cluster.Provider.reValidate') : t('Cluster.Provider.validate') }
                                    </Button>
                                </Grid>
                            }
                            {
                                this.state.permissionStatus &&
                                <Grid item lg={1} md={2} xs={6}>
                                    <Button variant="contained" color='primary' fullWidth onClick={() => this.handleContinue()} data-test="continue-btn">
                                        {t('Cluster.Provider.continue')}
                                    </Button>
                                </Grid>
                            }
                        </Grid>
                    </div>
                }
            </div>
        )
    }
}

/* istanbul ignore next */
const mapDispatchtoProps = (dispatch:Dispatch) => {
    return {
        validatePermission: (jsonBody: Partial<ClusterCreateModel>, uploadBody:FormData | null) => dispatch(validatePermission(jsonBody, uploadBody)),
        getProviderConfig: (provider:TclusterProvider["provider"]) => dispatch(getProviderConfig(provider))
    }
}

/* istanbul ignore next */
const mapStateToProps = (state:any) => {
    return {
        validationData: state.ClusterReducer.validationData,
        isValidatingPermission: state.ClusterReducer.isValidatingPermission,
        gcpFilePath: state.ClusterReducer.gcpFilePath,
        providerConfig: state.ClusterReducer.providerConfig
    }
}

const connector=connect(
    mapStateToProps,
    mapDispatchtoProps
)
export default connector(
    compose(
        withStyles,
    )(useStyles)(withTranslation()(Provider))
)
type PropsFromRedux=ConnectedProps<typeof connector>
